import React from 'react';

import { I18n } from 'js/components/common/I18n';
import { Button } from 'js/components/common/Button';

export const JumioStepPassed = ({ translate, handlerAfterPassed }) =>
    <div className="id-verification id-verification__result">
        <div className="id-verification__result_message">
            <I18n t={translate} tKey='passed-message' />
        </div>
        <div className="id-verification__result-buttons">
            <Button size='medium' onClick={handlerAfterPassed}>
                { translate('button.after-passed-text') }
            </Button>
        </div>
    </div>;
